import type { UpdateVenueRequest, VenueDetailed } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

export function updateVenueDetails(venueId: string, formData: UpdateVenueRequest): Promise<VenueDetailed> {
  return requestApiJsonOrThrow<VenueDetailed>(`admin/venues/${venueId}`, {
    method: 'PATCH',
    body: formData,
  })
}
